function requireAuth(to, from, next) {
  $.ajax({
    url: api_url + 'users/checkLogin/' + sessionStorage.getItem("belepteto_apikey"),
    dataType: 'json',
    success: function (response) {
      if (response.status == "OK") {
        next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }
  });
}

import Vue from 'vue';
import VueRouter from 'vue-router';
import components from './components/components.vue';
import App from './components/app.vue'
import Home from './components/home.vue';
import Users from './components/users.vue';
import User from './components/user.vue';
import Cards from './components/cards.vue';
import Card from './components/card.vue';
import CardGroups from './components/cardgroups.vue';
import CardGroup from './components/cardgroup.vue';
import Log from './components/log.vue';
import DeviceLog from './components/device_log.vue';
import DaemonLog from './components/daemon_log.vue';
import Filter from './components/filter.vue';
import Opening from './components/opening.vue';
import RemoteOpen from './components/remote_open.vue';
import Login from './components/login.vue';
import Logout from './components/logout.vue';
import Buildings from './components/buildings.vue';
import Building from './components/building.vue';
import BuildingLevels from './components/building_levels.vue';
import BuildingLevel from './components/building_level.vue';
import Gateways from './components/gateways.vue';
import Gateway from './components/gateway.vue';
import Connections from './components/connections.vue';
import Connection from './components/connection.vue';
import Controllers from './components/controllers.vue';
import Controller from './components/controller.vue';
import Readers from './components/readers.vue';
import Reader from './components/reader.vue';
import Doors from './components/doors.vue';
import Door from './components/door.vue';
import Barriers from './components/barriers.vue';
import Barrier from './components/barrier.vue';
import Turnstiles from './components/turnstiles.vue';
import Turnstile from './components/turnstile.vue';
import Groups from './components/groups.vue';
import Group from './components/group.vue';
import Relays from './components/relays.vue';
import Relay from './components/relay.vue';
import Plates from './components/plates.vue';
import Plate from './components/plate.vue';
import Schedules from './components/schedules.vue';
import Schedule from './components/schedule.vue';
import Dateintervals from './components/dateintervals.vue';
import Dateinterval from './components/dateinterval.vue';
import AccessLevels from './components/access_levels.vue';
import AccessLevel from './components/access_level.vue';
import Operations from './components/operations.vue';
import Message from './components/message.vue';
import Profilmenu from './components/profilmenu.vue';
import Search from './components/search.vue';
import HTMLHeader from './components/tpl_header.vue';
import HTMLFooter from './components/tpl_footer.vue';
import HTMLMenu from './components/tpl_menu.vue';
import BarcodeRequest from './components/barcode_request.vue';
import BarcodeApproval from './components/barcode_approval.vue';
import Barcodes from './components/barcodes.vue';
import Status from './components/status.vue';
import WorkTime from './components/worktime.vue';
import Report from './components/report.vue';
global.moment = require("moment");

Vue.use(VueRouter)

const router = new VueRouter({
  base: __dirname,
  routes: [
    { path: '*', component: Home, beforeEnter: requireAuth },
    { path: '/users/list', component: Users, beforeEnter: requireAuth },
    { path: '/user/edit', component: User, beforeEnter: requireAuth },
    { path: '/user/edit/*', component: User, beforeEnter: requireAuth },
    { path: '/cards', component: Cards, beforeEnter: requireAuth },
    { path: '/card/edit', component: Card, beforeEnter: requireAuth },
    { path: '/cardgroups', component: CardGroups, beforeEnter: requireAuth },
    { path: '/cardgroup/edit', component: CardGroup, beforeEnter: requireAuth },
    { path: '/controllers', component: Controllers, beforeEnter: requireAuth },
    { path: '/controller/edit', component: Controller, beforeEnter: requireAuth },
    { path: '/buildings', component: Buildings, beforeEnter: requireAuth },
    { path: '/building/edit', component: Building, beforeEnter: requireAuth },
    { path: '/building_levels', component: BuildingLevels, beforeEnter: requireAuth },
    { path: '/building_level/edit', component: BuildingLevel, beforeEnter: requireAuth },
    { path: '/gateways', component: Gateways, beforeEnter: requireAuth },
    { path: '/gateway/edit', component: Gateway, beforeEnter: requireAuth },
    { path: '/connections', component: Connections, beforeEnter: requireAuth },
    { path: '/connection/edit', component: Connection, beforeEnter: requireAuth },
    { path: '/readers', component: Readers, beforeEnter: requireAuth },
    { path: '/reader/edit', component: Reader, beforeEnter: requireAuth },
    { path: '/doors', component: Doors, beforeEnter: requireAuth },
    { path: '/door/edit', component: Door, beforeEnter: requireAuth },
    { path: '/barriers', component: Barriers, beforeEnter: requireAuth },
    { path: '/barrier/edit', component: Barrier, beforeEnter: requireAuth },
    { path: '/turnstiles', component: Turnstiles, beforeEnter: requireAuth },
    { path: '/turnstile/edit', component: Turnstile, beforeEnter: requireAuth },
    { path: '/groups', component: Groups, beforeEnter: requireAuth },
    { path: '/group/edit', component: Group, beforeEnter: requireAuth },
    { path: '/relays', component: Relays, beforeEnter: requireAuth },
    { path: '/relay/edit', component: Relay, beforeEnter: requireAuth },
    { path: '/plates', component: Plates, beforeEnter: requireAuth },
    { path: '/plate/edit', component: Plate, beforeEnter: requireAuth },
    { path: '/schedules', component: Schedules, beforeEnter: requireAuth },
    { path: '/schedule/edit', component: Schedule, beforeEnter: requireAuth },
    { path: '/dateintervals', component: Dateintervals, beforeEnter: requireAuth },
    { path: '/dateintervals/edit', component: Dateinterval, beforeEnter: requireAuth },
    { path: '/access_levels', component: AccessLevels, beforeEnter: requireAuth },
    { path: '/access_level/edit', component: AccessLevel, beforeEnter: requireAuth },
    { path: '/operations', component: Operations, beforeEnter: requireAuth },
    { path: '/log', component: Log, beforeEnter: requireAuth },
    { path: '/device_log', component: DeviceLog, beforeEnter: requireAuth },
    { path: '/parking_log', component: DaemonLog, beforeEnter: requireAuth },
    { path: '/building_log', component: DaemonLog, beforeEnter: requireAuth },
    { path: '/filter', component: Filter, beforeEnter: requireAuth },
    { path: '/opening', component: Opening, beforeEnter: requireAuth },
    { path: '/msg', component: Message },
    { path: '/login', component: Login },
    { path: '/logout', component: Logout },
    { path: '/teszt', component: Home, beforeEnter: requireAuth },
    { path: '/barcode_request', component: BarcodeRequest, beforeEnter: requireAuth },
    { path: '/barcode_approval', component: BarcodeApproval, beforeEnter: requireAuth },
    { path: '/barcode_list', component: Barcodes, beforeEnter: requireAuth },
    { path: '/remote_open', component: RemoteOpen, beforeEnter: requireAuth },
    { path: '/status', component: Status },
    { path: '/worktime', component: WorkTime, beforeEnter: requireAuth },
    { path: '/report', component: Report, beforeEnter: requireAuth }
  ]
});

window.api_url = 'api/';

var vue = new Vue({
  data: {
    version: '2024.07.13.0.16',
    user: {},
    profilmenu: false,
    searchmenu: false,
    interval: '',
    pageMsg: {
      type: '',
      text: ''
    },
    socket: '',
    menus: [
      {
        id: 'm2',
        link: '',
        jump: 'm21',
        label: 'Felhasználók',
        icon: 'fa fa-user',
        level: 1,
        subs: [
          {
            id: 'm21',
            link: '/users/list',
            label: 'Lista',
            icon: 'fa fa-users',
            parents: ['m2'],
            level: 2
          },
          {
            id: 'm22',
            link: '/user/edit',
            label: 'Új',
            icon: 'fa fa-user-plus',
            parents: ['m2'],
            level: 2
          },
          {
            id: 'm23',
            link: '/filter',
            label: 'Szűrő',
            icon: 'fa fa-filter',
            level: 1
          }
        ]
      },
      {
        id: 'm3',
        link: '/cards',
        label: 'Kártyák',
        icon: 'fa fa-address-card',
        level: 1,
        subs: [
          /*
          {
            id: 'm33',
            link: '/cardgroups',
            label: 'Kártya csoport',
            icon: 'fa fa-object-group',
            parents: ['m3'],
            level: 2,
            subs: [
              {
                id: 'm331',
                link: '/cardgroup/edit',
                label: 'Új csoport',
                icon: 'fa fa-object-group',
                parents: ['m3','m33'],
                level: 3
              }
            ]
          }*/
        ]
      },
      {
        id: 'm12',
        link: '',
        label: 'QR kódok',
        icon: 'fas fa-qrcode',
        level: 1,
        subs: [
          {
            id: 'm121',
            link: '/barcode_request',
            label: 'Igénylés',
            icon: 'fas fa-plus',
            parents: ['m12'],
            level: 2
          },
          {
            id: 'm122',
            link: '/barcode_approval',
            label: 'Jóváhagyás',
            icon: 'fas fa-check',
            parents: ['m12'],
            level: 2
          },
          {
            id: 'm123',
            link: '/barcode_list',
            label: 'Lista',
            icon: 'fas fa-qrcode',
            parents: ['m12'],
            level: 2
          }
        ]
      },
      {
        id: 'm13',
        link: '/remote_open',
        label: 'Távoli nyitás',
        icon: 'fa fa-lock-open',
        level: 1
      },
      //      {
      //        id: 'm4',
      //        link: '/access',
      //        label: 'Hozzáférés',
      //        icon: 'fa fa-sign-in-alt',
      //        level: 1
      //      },
      {
        id: 'm5',
        link: '',
        jump: 'm53',
        label: 'Logok',
        icon: 'customicon customicon-logicon',
        level: 1,
        subs: [
          {
            id: 'm53',
            link: '/building_log',
            label: 'Épület log',
            icon: 'far fa-building',
            parents: ['m5'],
            level: 2
          },
          /*{
            id: 'm51',
            link: '/device_log',
            label: 'NC parkolás',
            icon: 'fas fa-parking',
            parents: ['m5'],
            level: 2
          },*/
          {
            id: 'm52',
            link: '/parking_log',
            label: 'Parkoló log',
            icon: 'fas fa-parking',
            parents: ['m5'],
            level: 2
          },
          {
            id: 'm54',
            link: '/log',
            label: 'Admin log',
            icon: 'fas fa-sliders-h',
            parents: ['m5'],
            level: 2
          },
        ]
      },
      {
        id: 'm7',
        link: '/groups',
        label: 'Csoportok',
        icon: 'customicon customicon-groups',
        level: 1
      },
      {
        id: 'm8',
        link: '',
        jump: 'm81',
        label: 'Schedules',
        icon: 'fa fa-calendar',
        level: 1,
        subs: [
          {
            id: 'm81',
            link: '/schedules',
            label: 'Lista',
            icon: 'far fa-calendar',
            parents: ['m8'],
            level: 2
          },
          {
            id: 'm82',
            link: '/dateintervals',
            label: 'Dátumok',
            icon: 'fas fa-calendar',
            parents: ['m8'],
            level: 2
          },
        ]
      },
      {
        id: 'm9',
        link: '/access_levels',
        label: 'Access Levels',
        icon: 'fas fa-user-shield',
        level: 1
      },
      {
        id: 'm14',
        link: '/opening',
        label: 'Nyitvatartások',
        icon: 'far fa-clock',
        level: 1
      },
      {
        id: 'm18',
        link: '/report',
        label: 'Átjáró riport',
        icon: 'fas fa-list-alt',
        level: 1
      },
      {
        id: 'm17',
        link: '/worktime',
        label: 'Munkaidő',
        icon: 'fa fa-calendar-check',
        level: 1
      },
      {
        id: 'm6',
        link: '',
        label: 'Eszközök',
        icon: 'fa fa-cog',
        level: 1,
        subs: [
          {
            id: 'm61',
            link: '/buildings',
            label: 'Épületek',
            icon: 'far fa-building',
            parents: ['m6'],
            level: 2,
            //            subs: [
            //              {
            //                id: 'm611',
            //                link: '/building/edit',
            //                label: 'Épület módosítás',
            //                icon: '',
            //                parents: ['m6', 'm61'],
            //                level: 3
            //              }
            //            ]
          },
          {
            id: 'm62',
            link: '/building_levels',
            label: 'Szintek',
            icon: 'fa fa-align-justify',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm63',
            link: '/gateways',
            label: 'Gateways',
            icon: 'customicon customicon-gateway',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm64',
            link: '/connections',
            label: 'Connections',
            icon: 'fa fa-plug',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm65',
            link: '/controllers',
            label: 'Kontrollerek',
            icon: 'fab fa-elementor',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm66',
            link: '/readers',
            label: 'Olvasók',
            icon: 'customicon customicon-cardreader',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm67',
            link: '/relays',
            label: 'Relék',
            icon: 'customicon customicon-relay',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm68',
            link: '/doors',
            label: 'Ajtók',
            icon: 'customicon customicon-door',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm69',
            link: '/barriers',
            label: 'Sorompók',
            icon: 'customicon customicon-barrier',
            parents: ['m6'],
            level: 2
          },
          {
            id: 'm610',
            link: '/turnstiles',
            label: 'Forgóvillák',
            icon: 'customicon customicon-turnstile',
            parents: ['m6'],
            level: 2
          }
        ]
      },
      /*{
        id: 'm10',
        link: '/operations',
        label: 'Műveletek',
        icon: 'fas fa-tasks',
        level: 1
      },*/
      /*{
        id: 'm15',
        link: '/plates',
        label: 'Rendszámok',
        icon: 'customicon customicon-car',
        level: 1
      },*/
      {
        id: 'm16',
        link: '/logout',
        label: 'Kilépés',
        icon: 'fa fa-power-off',
        level: 1
      }
    ]
  },
  watch: {
    '$route': 'routerChange'
  },
  mounted: function () {
    var _this = this;

    if (sessionStorage.getItem("belepteto_apikey")) {
      this.ajax('users/checkLogin/' + sessionStorage.getItem("belepteto_apikey"), {
        success: function (response) {
          _this.user = response.user;
        }
      });
    }
  },
  methods: {
    setFloatingButtons: function () {
      Vue.nextTick(function () {
        $(window).scroll(function () {
          if ($('.floating-buttons').length == 0)
            return;

          if ($(window).scrollTop() > $('header').outerHeight()) {
            $('.floating-buttons').css({
              position: 'fixed',
              top: 0,
              right: $(window).innerWidth() - ($('.floating-buttons').parents('.container').offset().left + $('.floating-buttons').parents('.container').width() + 15),
            });
          } else {
            $('.floating-buttons').css({
              position: 'absolute',
              top: -20,
              right: 15,
            });
          }
        });
      });
    },

    routerChange: function () {
      if (this.interval != undefined)
        clearInterval(this.interval);

      this.setFloatingButtons();
    },

    toggleProfilMenu: function () {
      this.profilmenu = !this.profilmenu;
      this.searchmenu = false;
    },

    toggleSearchMenu: function () {
      this.searchmenu = !this.searchmenu;
      this.profilmenu = false;
    },

    checkRight: function (right_alias) {
      var in_arr = false;

      if (this.user.rights != undefined && this.user.rights.length > 0) {
        this.user.rights.map(function (right, i) {
          if (right == right_alias)
            in_arr = true;
        });
      }

      return in_arr;
    },
    checkRootUserHasSet: function (cb) {
      var _this = this;

      if (sessionStorage.getItem("belepteto_apikey")) {
        var interval = setInterval(function () {
          if (_this.user.apikey != undefined) {
            clearInterval(interval);
            if ($.isFunction(cb))
              cb();
          }
        }, 10);
      }
    },
    generateGUID: function () {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    ajax: function (url, user_options) {
      var _this = this;

      // Verzió ellenőrzés
      $.ajax({
        url: api_url + 'getVersion/' + _this.version,
        dataType: 'json',
        success: function (response) {
          if (response.status == 'ERROR') {
            swal('Figyelem', response.msg, 'error');
            return;
          } else {
            _this.callajax(url, user_options);
          }
        }
      });
    },
    callajax: function (url, user_options) {
      var _this = this;

      var options = {
        method: 'GET',
        dataType: 'json',
        data: {},
        async: true,
        success: function () { },
        error: function () { },
        waitForSaveInfo: false
      };

      var options = $.extend({}, options, user_options);

      try {
        if (url == undefined)
          throw 'Url hiányzik';

        $.ajax({
          method: options.method,
          url: api_url + url,
          async: options.async,
          data: options.data,
          cache: false,
          timeout: 1800000,
          dataType: options.dataType,
          error: options.error,
          beforeSend: options.beforeSend ? options.beforeSend : () => { },
          success: function (response) {
            if (response.status == "OK") {
              setTimeout(function () {
                options.success(response);
              }, options.waitForSaveInfo ? 500 : 0);

            } else if (response.status == "NO_ACCESS") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Nincs joga a művelethez'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "NO_LOGGED_USER") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Nem található bejelentkezett felhasználó.'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "NO_API_KEY") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Nem található API kulcs'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "NO_VALID_API_KEY") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Érvénytelen az API kulcs'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "ERROR") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: response.msg
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "DATABASE_ERROR") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: response.text
              };
              _this.$router.push({ path: '/msg' });
            }
          }
        });

      } catch (error) {
        alert(error);
      }
    }
  },
  router,
  render: h => h(App)
}).$mount('#app-container');



// WEBPACK FOOTER //
// ./main.js